import React from 'react';
import VideoLoop from '../VideoLoop'
import Photo from '../Photo'
import styled from 'styled-components'
const VidThirds = styled.div`
    .vid-one-third {
        grid-area: vid-1;
    }
    .img-two-third {
        grid-area: img-1-3;
    }

    .vid-23-grid {
        display: grid;
        column-gap: 1rem;
        grid-template-columns: [vid-1] 2fr [img-1-3] 1fr;
        &.reverse {
            direction: rtl;
        }
        &.space {
            grid-template-columns: [vid-1] 7fr [spacer] 1fr [img-1-3] 4fr;
        }
`
const VideoLoop13 = ({videoURL, descriptiveText, localFile, altText, reverse, space}) => {
    let classOptions
    if(reverse && space) {
        classOptions ="reverse space vid-23-grid"
    }
    else if(reverse) {
        classOptions= "reverse vid-23-grid"
    } 
    else if(space) {
        classOptions = "space vid-23-grid"
    } else {
        classOptions = "vid-23-grid"
    }

  return (
      <VidThirds className="row-component">
          <div className={classOptions}>
                <div className="vid-one-third">
                   {localFile && <Photo localFile={localFile} altText={altText} />}
                </div>
                <div className="img-two-third">
                    <VideoLoop src={videoURL} description={descriptiveText} />
                </div>
            </div>
      </VidThirds>
  );
};

export default VideoLoop13;
